export const LOGOUT = 'LOGOUT';

export const SET_ID_TOKEN = 'SET_ID_TOKEN';
export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';


// WEBPACK FOOTER //
// ./src/store/modules/user/user.types.js